/* eslint-disable max-classes-per-file */
/* eslint-disable no-this-before-super */
/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import "phaser";
import { Entity } from './Entity'
import { loadAudio, loadSpritesheet, createAnimation } from "./../modules/utiltes"
import { SoundManager } from "../ScenesHelpers/SoundManager";
export class Shield extends Entity {
    /** 
     * Shield constructor @param {object} scene -scene that Shield object belongs to- @param {number} x - value of Shield on x axis - @param {number} y - value of Shield on y axis - @param {String} key -contains key of Shield- @param {String} type -type of Shield - @param {number} level -level of Shield- @param {number} scalex -scale Shield in x axis- @param {number} scaley -scale Shield in y axis- @param {string}audio -contains key of audio-@param {string} animekey -contains key of animation-
     * loadAssets function : load asset on screen and it takes @param {object} scene -scene that Shield object belongs to-  @param {String} key -key of Shield asset-  @param {String} keyLink -path of asset location- @param {number} framex - number of frames of animation of x axis- @param {number} framey - number of frames of animation of y axis-@param {String} audio -contains key of Shield audio- @param {String} audioLink -contains path of Shield audio-
     * loadAnime function :  createAnimation  @param {Object} scene @param {object} scene -scene that Shield object belongs to- @param {String} key -key of Shield asset-  @param {number} framex - number of frames of animation of x axis- @param {boolean} load -load or not-
     * */
    constructor(scene, x, y, key, type, level, scalex, scaley, animekey, audio) {
        super(scene, x, y, key, type);
        this.setData("shieldkey", key);
        this.setData("shieldlevel", level);
        this.setDepth(2);
        this.level = level;
        this.scaleX = scalex;
        this.scaleY = scaley;
        this.audio = audio;
        if (animekey != null) {
            super.setTexture(animekey);
            super.play(animekey);
        }
    }
    static loadAssets(scene, key, framex, framey, audio, keylink, audiolink) {
        loadSpritesheet(scene, `${key}`, `${keylink}`, framex, framey)
        loadAudio(scene, `${audio}`, `${audiolink}`)
    }
    static loadAnime(scene, key, framex, load) {
        if (load) {
            createAnimation(scene, `${key}`, framex, -1)
        }
    }
}